import { useAuthMutation } from './auth'
import { ApiStudentRequest, request } from '../utils'
import { StudentApplication } from '../components/Application/types'

type SubmitApplicationProps = {
  id: string
}

type RawApplicationsResponse = {
  data: StudentApplication
}

export function useSubmitApplication(props: SubmitApplicationProps) {
  const { isPending, mutate } = useAuthMutation(async (params: undefined) => {
    return await request<RawApplicationsResponse>(
      new ApiStudentRequest(`/applications/${props.id}/submit`, {
        method: 'POST',
      }),
      {
        isExpectedResponse: (res): res is RawApplicationsResponse => res as boolean,
      },
    )
  })

  return {
    isSubmittingApplication: isPending,
    submitApplication: mutate,
  }
}
